import { render, staticRenderFns } from "./TrafficLightDistributionChart.vue?vue&type=template&id=23a3808c"
import script from "./TrafficLightDistributionChart.vue?vue&type=script&lang=js"
export * from "./TrafficLightDistributionChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports